import React from 'react'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'

export const NoMakerHubArticlesFound = () => {
  return (
    <div className='flex justify-center'>
      <Typography variant={TypographyVariant.Heading5} tag={TypographyTag.h4}>
        <span className='text-center'>No Articles & Guides Found</span>
      </Typography>
    </div>
  )
}
